<!-- 
*****************************************************************************
**                                                                         **
** Copyright (c) 2012-2024, Tyker Technology BV                            **
** All rights reserved.                                                    **
**                                                                         **
** This software is the confidential and proprietary information of        **
** Tyker Technology BV. Unauthorized copying or disclosure of this file,   **
** via any medium is strictly prohibited. This file is only available to   **
** authorized individuals with the permission of the copyright holders.    **
** If you encounter this file and do not have permission, please contact   ** 
** the copyright holders and delete this file.                             **
**                                                                         **
***************************************************************************** 
-->

<template>
    <v-dialog
        v-model="dialog"
        persistent
        id="changePassword"
        width="500px"
        :fullscreen="$vuetify.breakpoint.xsOnly"
    >
        <v-card :loading="saving">
            <template slot="progress">
                <v-progress-linear
                    height="10"
                    indeterminate
                ></v-progress-linear>
            </template>
            <v-card-title class="py-6">
                <div class="text-h6 text-sm-h4">{{ language.t('ChangePassword.changePassword') }}</div>
                <v-spacer></v-spacer>
                <v-btn
                    icon
                    color="blue darken-1"
                    @click="$emit('close');"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-form
                    ref="form"
                    v-model="valid"
                    lazy-validation
                    v-on:submit.prevent="changePassword"
                >
                    <v-text-field
                        v-model="form.firstPassword"
                        type="password"
                        :label="'*' + language.t('ChangePassword.newPassword') + ' (' + language.t('Forms.requiredPasswordCharacters') + ')'"
                        :rules="firstPasswordRules"
                    ></v-text-field>
                    <v-text-field
                        v-model="form.secondPassword"
                        type="password"
                        :label="'*' + language.t('ChangePassword.repeatPassword')"
                        :rules="[passwordConfirmationRules]"
                    >
                    </v-text-field>
                    <p class="text-right">* = {{ language.t('Forms.requiredFields') }}</p>
                    <v-btn
                        color="success"
                        class="mr-4"
                        type="submit"
                        :disabled="!complete || !valid"
                        :loading="saving"
                    >
                        {{ language.t('App.save') }}
                    </v-btn>
                </v-form>
            </v-card-text>
            <v-card-actions class="card-actions">
                <v-spacer></v-spacer>
                <v-btn
                    color="blue darken-1"
                    text
                    @click="$emit('close');"
                >
                    <v-icon>mdi-close</v-icon>{{ language.t('App.close') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    components: {
    },
    props: {},
    data() {
        return {
            dialog: true,
            complete: false,
            saving: false,
            error: null,
            success: false,
            valid: true,
            form: {
                firstPassword: "",
                secondPassword: ""
            },
            firstPasswordRules: [
                v => !!v || this.language.t('FormRules.passwordRequired'),
                v => v.length >= 8 || this.language.t('FormRules.passwordLength'),
            ],
        };
    },
    mounted: function () {
    },
    computed: {
        passwordConfirmationRules() {
            return this.form.firstPassword === this.form.secondPassword || this.language.t('FormRules.passwordValidation');
        }
    },
    watch: {
        form: {
            /* validate if the form data is complete */
            handler(val) {
                if (val.firstPassword != "" && val.secondPassword != "")
                    this.complete = true;
                else
                    this.complete = false;

                if (val.firstPassword != val.secondPassword)
                    this.valid = false;
            },
            deep: true
        }
    },
    methods: {
        changePassword() {
            if (this.form.firstPassword === this.form.secondPassword) {
                this.saving = true;
                this.error = null;
                let data = new FormData();
                data.set('password', this.form.firstPassword);

                this.$axios.post(route('api.customer.password.update'), data, { headers: { 'Content-Type': 'multipart/form-data' } })
                    .then((res) => {
                        console.log(res.statusText);
                        this.success = true;
                        this.saving = false;
                        this.$emit("close")
                    })
            }
        },
        onClose() {
            this.$emit("close");
        },
    },
};
</script>

